import React, { PropsWithChildren } from 'react';
import { gql } from '@yi/core';

import { MixCardsCarousel, getDefaultMixCardsCarouselProps } from './carousels';
import { BaseCarouselComposerProps } from './carousels/BaseCarousel';

const defaultProps = getDefaultMixCardsCarouselProps();

type CarouselItem = gql.typesClient.Fragment_MeditationCard | gql.typesClient.Fragment_ClassCard;
type Props = BaseCarouselComposerProps<CarouselItem>;

export const PranayamasCarousel: React.FC<PropsWithChildren<Props>> = props => {
  if (!props.items.length) return null;
  return <MixCardsCarousel {...defaultProps} {...props} />;
};
